module.exports = __webpack_public_path__ + "img/nodata-03.32e20536.png";